import React, { useEffect, useState } from 'react';
import PurchaseTable from './PurchaseTable';
import useAxios from 'hooks/useAxios';
import { cloneDeep } from 'lodash';
import { onExport } from 'utils/helper';


let initialFilters = {
    currentPage: 1,
    pageSize: 10,
    orderBy: '',
    order: '',
    filters: [],
    AccumulatorIDs: [],
    AccountTypeID: '',
  };

const Purchase = ({ tenantID,orgId, rowData, AccountTypeID,recall }) => {
    const API = useAxios();
    const [state, updateState] = useState({
        data: [],
        //coveredEntity: [],
        loading: false,
        selectedEntity: '',
        coveredId: '',
        records: 0,
        reset: false,
    });
    const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));
    const [colFilter, setColFilter] = useState([]);
    useEffect(() => {
        initialFilters = {
            currentPage: 1,
            pageSize: 10,
            orderBy: '',
            order: '',
            filters: [],
            AccumulatorIDs: [],
            AccountTypeID: '',
        };
        setState({ data: [], records: 0 });
        if (rowData) {
            var acIds = [];
            const { accumulatorID } = rowData;
            acIds = accumulatorID;
            initialFilters.AccountTypeID = AccountTypeID;
            initialFilters.currentPage = 1;
            initialFilters.AccumulatorIDs = [acIds];
            initialFilters.order = 'desc';
            initialFilters.orderBy = 'ModifiedDate';

            fetchPurchaseData(initialFilters);
        }
    }, [AccountTypeID]);

    const fetchPurchaseData = async (pageDetails = {}, hasColumnFilter) => {
        debugger;
        setState({ loading: true });
        let filter = { ...pageDetails };
        if (hasColumnFilter) {
            filter.filters = [...initialFilters.filters, ...pageDetails.filters];
            //initialFilters.filters = [...filter.filters];
        } else {
            initialFilters = { ...initialFilters, ...filter };
        }
        try {
            const { data } = await API.post(
                `SBTenant/${tenantID}/Inventory/Purchase/${rowData.ndc}`, filter,
                {
                    hasDefaultURL: true,
                    hideLoder: true,
                });
            if (data?.items?.length > 0) {
                setState({
                    data: data.items,
                    records: data.totalRecords,
                    loading: false,
                });
                recall(data.items)

            } else {
                setState({
                    data: [],
                    records: 0,
                    loading: false,
                });
            }
        } catch (error) {
            console.error('API Error:', error);
            setState({ loading: false, data: [], records: 0 });
        }
    };
   const handleExport = async () => {
       debugger;
       const filterObj = cloneDeep(initialFilters);
       if (colFilter?.filters?.length > 0) {
         filterObj.filters = [...filterObj.filters, ...colFilter.filters];
       }
   
       const { access_token } =
         JSON.parse(localStorage.getItem('pharmaforce')) || {};
   
         var additionalCriteria = {};
         additionalCriteria.IsSelectedColumn = false;
         additionalCriteria.OrgId = orgId.organizationID;
          // additionalCriteria.ContractId = 0;
        //additionalCriteria.POId = parseInt(rowData.ndc);
        additionalCriteria.OpaId = rowData.ndc;
       // additionalCriteria.CEId = 0;
       // additionalCriteria.ManufactureId = 0;
   
       var payload = {};
       payload.tenantID = tenantID
       payload.gridCode = "purchase";
       payload.fileTypeCode = "csv";
       payload.criteria = JSON.stringify(filterObj);
       payload.additionalCriteria = JSON.stringify(additionalCriteria);
       const { data } = await API.post(`export/queue`, payload, {
         hasExport: true,
       });
     //  const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${orgId.tenantID}/Reports/ExportManufacturerAlls?access_token=${access_token}`;
     //  onExport(action, initialFilters);
     };

    const handleSearchColumnFilters = async (columnFilters) => {
        initialFilters.currentPage = 1;
        setColFilter(columnFilters);
        await fetchPurchaseData({ ...initialFilters, ...columnFilters }, true);
    };

    const onPageChange = (filter, hasFilter) => {
        updatePurchaseInitialFilterSearch(filter);
        if (hasFilter) {
            fetchPurchaseData(filter, true);
        } else {
            fetchPurchaseData(filter);
        }
    };
    const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            return onPageChange(colFilterOn, true);
        }
        setState({
            filters: filter,
        });
        onPageChange(filter);
    };

    const updatePurchaseInitialFilterSearch = (filter) => {
     initialFilters.currentPage = filter.currentPage;
      initialFilters.pageSize = filter.pageSize;
       initialFilters.order = filter.order;
        initialFilters.orderBy = filter.orderBy;
  }

    const refetch = (hasReset) => {
        if (hasReset) {
            setColFilter([]);
            initialFilters = {
                ...initialFilters,
                currentPage: 1,
            };
        }
        fetchPurchaseData(initialFilters);
    };
    return (
        <div>
            <PurchaseTable
            onPageSizeChange={onPageSizeChange}
                data={state.data}
                loading={state.loading}
                onExport={handleExport}
                totalSize={state.records}
                filters={initialFilters}
                onPageChange={onPageChange}
                setLoading={(value) => setState({ loading: value })}
                onSearchColumnFilters={handleSearchColumnFilters}
                refetch={refetch} />
        </div>
    );
};

export default Purchase;
